export enum ReplayRecordingType {
    Old = "Old",
    New = "New",
    NotAllowed = "NotAllowed"
}